import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { format, isValid } from 'date-fns'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useStoreState } from '../../../../store/hooks'
import navigateToDate from '../../../PuzzlesView/helpers/navigateToDate'

const DailyPuzzleCalendar: React.FC = () => {
    const previousPuzzleAvailable = useStoreState((state) => state.dailyPuzzleViewV2.previousPuzzleAvailable)
    const nextPuzzleAvailable = useStoreState((state) => state.dailyPuzzleViewV2.nextPuzzleAvailable)
    const puzzle = useStoreState((state) => state.dailyPuzzleViewV2.puzzle)

    const [formattedDate, setFormattedDate] = useState('')

    const navigate = useNavigate()

    useEffect(() => {
        if (puzzle?.date && isValid(puzzle.date)) {
            setFormattedDate(format(puzzle.date, 'MMM dd').toUpperCase())
        }
    }, [puzzle?.date])

    const onPrev = () => {
        navigateToDate(navigate, puzzle?.date, false)
    }

    const onNext = () => {
        navigateToDate(navigate, puzzle?.date, true)
    }

    return (
        <Stack direction="row" alignItems="center" gap={1} sx={{ p: 1, maxHeight: '34px' }}>
            <IconButton onClick={onPrev} size="small" disabled={!previousPuzzleAvailable || !puzzle}>
                <ChevronLeftIcon color="secondary" />
            </IconButton>
            <Typography variant="h6" color="secondary">
                {formattedDate}
            </Typography>
            <IconButton onClick={onNext} size="small" disabled={!nextPuzzleAvailable || !puzzle}>
                <ChevronRightIcon color="secondary" />
            </IconButton>
        </Stack>
    )
}

export default DailyPuzzleCalendar
